module.exports = __webpack_public_path__ + "8e0f4018c2e6ab78f5d703d67a1ea25f.pdf";